/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Exception } from './Exception';
import {
    instanceOfException,
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * @type PtwImportDtoError
 * 
 * @export
 */
export type PtwImportDtoError = Exception;


export function PtwImportDtoErrorFromJSON(json: any): PtwImportDtoError {
    return PtwImportDtoErrorFromJSONTyped(json, false);
}

export function PtwImportDtoErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwImportDtoError {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ExceptionFromJSONTyped(json, true) };
    return  ExceptionFromJSONTyped(json, true);
}

export function PtwImportDtoErrorToJSON(value?: PtwImportDtoError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfException(value)) {
        return ExceptionToJSON(value as Exception);
    }

    return {};
}

/**
 * Check if a given object implements the PtwImportDtoError interface.
 */
export function instanceOfPtwImportDtoError(value: any): value is PtwImportDtoError {
    if (instanceOfException(value)) return true;
    return false;
}

